import { EdcSell } from "@remo-co/ui-core/src/icons/EdcSell";
import { EdcExperience } from "@remo-co/ui-core/src/icons/EdcExperience";
import { EdcBrowse } from "@remo-co/ui-core/src/icons/EdcBrowse";
import { EdcCalendar } from "@remo-co/ui-core/src/icons/EdcCalendar";
import { EdcPromote } from "@remo-co/ui-core/src/icons/EdcPromote";
import { EdcVirtual } from "@remo-co/ui-core/src/icons/EdcVirtual";
import { EDC_LINKS } from "@remo-co/constants/src/EdcLinks";

export const EDC_APPS = {
  TITLE: "EVENTS.COM APPS",
  APPS: [
    {
      id: "sell",
      title: "sell",
      description: "sell.description",
      icon: <EdcSell />,
      link: EDC_LINKS.SELL,
    },
    {
      id: "experience",
      title: "experience",
      description: "experience.description",
      icon: <EdcExperience />,
      link: EDC_LINKS.EXPERIENCE,
    },
    {
      id: "promote",
      title: "promote",
      description: "promote.description",
      icon: <EdcPromote />,
      link: EDC_LINKS.PROMOTE,
    },
    {
      id: "calendar",
      title: "calendar",
      description: "calendar.description",
      icon: <EdcCalendar />,
      link: EDC_LINKS.CALENDAR,
    },
    {
      id: "discover",
      title: "discover",
      description: "discover.description",
      icon: <EdcBrowse />,
      link: EDC_LINKS.DISCOVER,
    },
    {
      id: "virtual",
      title: "virtual",
      description: "virtual.description",
      icon: <EdcVirtual />,
      link: EDC_LINKS.VIRTUAL,
    },
  ],
};
